
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { RightType, DegreeType } from '../types/general'

const moment = extendMoment(Moment);

export const IS_IN_MILUIM = true; // opposite- Ben Zuge of 'in miluim'
export const BACHELOR = 'Bachelor';
export const MASTER = 'Master';
export const DOUBLE_DEGREE = 'Double Degree'
export const RIGHTS_OF_50_DAYS = '50DaysRights';
export const RIGHTS_OF_200_DAYS = '200DaysRights';
export const RIGHTS_OF_3_WEEK_FIRST = '3WeeksFirstRights';
export const RIGHTS_OF_3_WEEK_SECOND = '3WeeksSecondRights';
export const PTOR_NEKUDOT_ZCHOOT = RightType.NekudotZehut;
export const BINARY_COURSES_NUM = RightType.Course;

export const WAR_START_DATE = moment('2023-10-07')
export const SEMESTER_A_START_DATE = moment('2023-12-31')
export const SEMESTER_A_END_DATE = moment('2024-05-04')
export const SEMESTER_A_PERIOD = moment.range(SEMESTER_A_START_DATE, SEMESTER_A_END_DATE).snapTo('day');
export const SEMESTER_B_START_DATE = moment('2024-05-05')
export const SEMESTER_B_END_DATE = moment('2024-10-28')
export const SEMESTER_B_PERIOD = moment.range(SEMESTER_B_START_DATE, SEMESTER_B_END_DATE);

export const YEAR_23_24_PERIOD = moment.range(WAR_START_DATE, SEMESTER_B_END_DATE);


export const RightsConfig = new Map(
    [
        [IS_IN_MILUIM, new Map(
            [
                [DegreeType.Boger, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 5]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 6]
                            ]
                        )],
                    ]
                )],
                [DegreeType.Musmach, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 1],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                    ]
                )],
                [DegreeType.RefuaChishuvit, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 4],
                                [BINARY_COURSES_NUM, 7]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 4],
                                [BINARY_COURSES_NUM, 9]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 4],
                                [BINARY_COURSES_NUM, 5]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 10]
                            ]
                        )],
                    ]
                )],
                [DegreeType.BschoolMusmach, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 3],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 4]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 0]
                            ]
                        )],
                    ]
                )],
                [DegreeType.BschoolMaslulMuatz, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 3],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 2]
                            ]
                        )],
                        [RIGHTS_OF_200_DAYS, new Map(
                            [
                                [BINARY_COURSES_NUM, 6]
                            ]
                        )],
                    ]
                )]
            ]
        )],
        [!IS_IN_MILUIM, new Map(
            [
                [DegreeType.Boger, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                    ]
                )],
                [DegreeType.Musmach, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 1],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 1],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 1]
                            ]
                        )],
                    ]
                )],
                [DegreeType.RefuaChishuvit, new Map(
                    [
                        [RIGHTS_OF_3_WEEK_FIRST, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_3_WEEK_SECOND, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 2],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                        [RIGHTS_OF_50_DAYS, new Map(
                            [
                                [PTOR_NEKUDOT_ZCHOOT, 0],
                                [BINARY_COURSES_NUM, 3]
                            ]
                        )],
                    ]
                )],
            ]
        )],
    ]
);

export enum MalagTimePeriods {
    FROM_30_UP_TO_60_DAYS = 1,
    FROM_61_UP_TO_99_DAYS,
    FROM_100_AND_UP
}

// PTOR_NEKUDOT_ZCHOOT here doesn't include the Avney Pina Ptor, 'Bechavanah'.
export const MalagRights = new Map(
    [
        [MalagTimePeriods.FROM_30_UP_TO_60_DAYS, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 6],
                [BINARY_COURSES_NUM, 1]
            ]
        )],
        [MalagTimePeriods.FROM_61_UP_TO_99_DAYS, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 8],
                [BINARY_COURSES_NUM, 2]
            ]
        )],
        [MalagTimePeriods.FROM_100_AND_UP, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 10],
                [BINARY_COURSES_NUM, 3]
            ]
        )],
    ]
)
